/* =====================================================================
   PB COLLECTION (v0.1) — filtre, sortering og sider uden sidegenindlæsning.
   Henter KUN kollektions-sektionen (?section_id=…), cacher svar (frem/tilbage = øjeblikkeligt),
   forudindlæser næste side og det filter musen hviler på. URL'en følger med (kan deles/bogmærkes).
   ===================================================================== */
(function () {
  'use strict';
  var d = document, PB = window.PB;
  if (!PB) return;
  var TTL = 180000;

  function root() { return d.querySelector('[data-pb-collection]'); }
  function sectionURL(u) { var x = new URL(u, location.href); x.searchParams.set('section_id', root().getAttribute('data-section')); return x.toString(); }
  function formURL(form, toggle) {
    var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    if (toggle) {
      var k = toggle.name, v = toggle.value, all = p.getAll(k);
      if (toggle.checked) { p.delete(k); all.filter(function (x) { return x !== v; }).forEach(function (x) { p.append(k, x); }); }
      else p.append(k, v);
    }
    var sort = d.querySelector('[data-pb-sort]'); if (sort) p.set('sort_by', sort.value);
    return form.getAttribute('action') + '?' + p.toString();
  }
  function openKeys() { var r = root(), o = []; if (!r) return o; r.querySelectorAll('.pb-fg.is-open').forEach(function (x) { o.push(x.getAttribute('data-key')); }); return o; }

  function load(url, push, scroll) {
    var r = root(); if (!r) { location.href = url; return; }
    var keep = openKeys(), drawerOpen = !!d.querySelector('#pb-filters.is-open'), fScroll = (d.querySelector('#pb-filters .pb-filters__form') || {}).scrollTop || 0;
    r.classList.add('is-loading');
    PB.get(sectionURL(url), { ttl: TTL }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), nr = doc.querySelector('[data-pb-collection]');
      if (!nr) { location.href = url; return; }
      r.innerHTML = nr.innerHTML; r.setAttribute('style', nr.getAttribute('style') || ''); r.classList.remove('is-loading');
      keep.forEach(function (k) { var x = r.querySelector('.pb-fg[data-key="' + k + '"]'); if (x) { x.classList.add('is-open', 'is-instant'); var bt = x.querySelector('[data-pb-fg]'); if (bt) bt.setAttribute('aria-expanded', 'true'); } });
      setTimeout(function () { Array.prototype.forEach.call(r.querySelectorAll('.pb-fg.is-instant'), function (x) { x.classList.remove('is-instant'); }); }, 60);
      if (drawerOpen) { var f = d.querySelector('#pb-filters'); if (f) { f.style.transition = 'none'; f.classList.add('is-open'); var ff = f.querySelector('.pb-filters__form'); if (ff) ff.scrollTop = fScroll; void f.offsetWidth; f.style.transition = ''; } }
      if (push) history.pushState({ pb: 1 }, '', url);
      if (scroll) { var g = r.querySelector('.pb-coll__main'); if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(d.documentElement).getPropertyValue('--pb-header-h'), 10) || 0) - 12, behavior: 'smooth' }); }
      enhance();
      PB.emit('collection:update', { url: url });
      prefetchNext();
    }).catch(function () { location.href = url; });
  }
  /* ekstra UI i kollektionen — køres ved start og efter hver indlæsning (roden udskiftes) */
  function enhance() {
    var r = root(); if (!r) return;
    var dw = r.querySelector('[data-pb-desc]');
    if (dw) { var dd = dw.querySelector('.pb-coll__desc'), bt = dw.querySelector('[data-pb-desc-toggle]'); if (dd && bt) { var over = dd.scrollHeight > dd.clientHeight + 4; bt.classList.toggle('is-off', !over); bt.tabIndex = over ? 0 : -1; dw.classList.toggle('fits', !over); } }
    var gc = r.querySelector('[data-pb-gc]'); if (gc) chips(gc);
    var fl = r.querySelector('#pb-filters'); if (fl) dragClose(fl);
    fitTitle(r);
    Array.prototype.forEach.call(r.querySelectorAll('[data-pb-slider]'), slider);
  }
  /* mobil: titlen står altid på ÉN linje (skrifttypen gøres mindre til den passer), så headeren har samme højde */
  function fitTitle(r) {
    var h = r.querySelector('.pb-coll__head .pb-h1'); if (!h) return;
    h.style.fontSize = '';
    if (!window.matchMedia('(max-width:749px)').matches) return;
    var fs = parseFloat(getComputedStyle(h).fontSize) || 30;
    while (h.scrollWidth > h.clientWidth + 1 && fs > 14) { fs -= 1; h.style.fontSize = fs + 'px'; }
  }
  var fitT = null;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(function () { var r = root(); if (r) fitTitle(r); }, 120); });
  /* filter-kortet på mobil: træk ned for at lukke (fra toppen, eller når listen står øverst) */
  function dragClose(f) {
    if (f.__drag) return; f.__drag = 1;
    var mob = function () { return window.matchMedia('(max-width:1000px)').matches; };
    var sx = null, sy = null, dy = 0, t0 = 0, on = false, head = false;
    f.addEventListener('touchstart', function (e) {
      if (!mob() || !f.classList.contains('is-open') || e.touches.length !== 1) { sy = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dy = 0; t0 = Date.now(); on = false;
      head = !!e.target.closest('.pb-filters__head') && !e.target.closest('button');
    }, { passive: true });
    f.addEventListener('touchmove', function (e) {
      if (sy === null) return;
      var ddy = e.touches[0].clientY - sy, ddx = e.touches[0].clientX - sx;
      if (!on) {
        if (ddy < 8 || Math.abs(ddx) > ddy || e.target.closest('input[type=range]')) return;
        var form = f.querySelector('.pb-filters__form'); if (!head && form && form.scrollTop > 0) return;
        on = true; f.classList.add('is-drag');
      }
      dy = Math.max(0, ddy); e.preventDefault(); f.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    f.addEventListener('touchend', function () {
      if (sy === null) return; sy = null;
      if (!on) return; on = false;
      var v = dy / Math.max(1, Date.now() - t0);
      f.classList.remove('is-drag'); f.style.transform = '';
      if (dy > 110 || v > 0.55) { f.classList.remove('is-open'); PB.lock(false); }
    }, { passive: true });
  }
  function chips(w) {
    var t = w.querySelector('[data-pb-gc-track]'), pv = w.querySelector('[data-pb-gc-prev]'), nx = w.querySelector('[data-pb-gc-next]');
    if (!t || t.__pb) return; t.__pb = 1;
    function edges() { var l = t.scrollLeft > 2, rr = t.scrollLeft < t.scrollWidth - t.clientWidth - 2; t.style.setProperty('--fl', l ? '36px' : '0px'); t.style.setProperty('--fr', rr ? '36px' : '0px'); if (pv) pv.hidden = !l; if (nx) nx.hidden = !rr; }
    t.addEventListener('scroll', edges, { passive: true }); window.addEventListener('resize', edges); edges();
    var on = t.querySelector('.pb-gamechip.is-on'); if (on && on.offsetLeft + on.offsetWidth > t.clientWidth) t.scrollLeft = on.offsetLeft - 40;
    if (pv) pv.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.7, behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.7, behavior: 'smooth' }); });
    var dr = null, mv = false;
    t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; dr = { x: e.clientX, sl: t.scrollLeft }; mv = false; });
    t.addEventListener('pointermove', function (e) { if (!dr) return; var dx = e.clientX - dr.x; if (!mv) { if (Math.abs(dx) < 5) return; mv = true; t.classList.add('is-drag'); } t.scrollLeft = dr.sl - dx; });
    function end() { dr = null; if (mv) { t.classList.remove('is-drag'); setTimeout(function () { mv = false; }, 0); } }
    t.addEventListener('pointerup', end); t.addEventListener('pointerleave', end); t.addEventListener('pointercancel', end);
    t.addEventListener('click', function (e) { if (mv) { e.preventDefault(); e.stopPropagation(); } }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function slider(sl) {
    if (sl.__pb) return; sl.__pb = 1;
    var lo = sl.querySelector('[data-lo]'), hi = sl.querySelector('[data-hi]'), fill = sl.querySelector('[data-fill]'), max = parseFloat(sl.getAttribute('data-max')) || 100;
    var box = sl.closest('.pb-fg') || sl.parentElement, nLo = box.querySelector('input[type=number][name$="gte"]'), nHi = box.querySelector('input[type=number][name$="lte"]');
    if (!lo || !hi || !nLo || !nHi) return;
    function paint() { fill.style.left = (Math.min(+lo.value, +hi.value) / max * 100) + '%'; fill.style.right = (100 - Math.max(+lo.value, +hi.value) / max * 100) + '%'; }
    function sync(e) { if (+lo.value > +hi.value) { if (e.target === lo) lo.value = hi.value; else hi.value = lo.value; } paint(); nLo.value = +lo.value > 0 ? lo.value : ''; nHi.value = +hi.value < max ? hi.value : ''; }
    lo.addEventListener('input', sync); hi.addEventListener('input', sync);
    function commit() { nLo.dispatchEvent(new Event('input', { bubbles: true })); }
    lo.addEventListener('change', commit); hi.addEventListener('change', commit);
    [nLo, nHi].forEach(function (n) { n.addEventListener('input', function () { lo.value = nLo.value || 0; hi.value = nHi.value || max; paint(); }); });
    paint();
  }
  function prefetchNext() { PB.idle(function () { var n = d.querySelector('[data-pb-collection] [data-pb-next]'); if (n) PB.get(sectionURL(n.href), { ttl: TTL }).catch(function () {}); }); }

  PB.ready(function () {
    if (!root()) return;
    history.replaceState({ pb: 1 }, '', location.href);
    enhance();
    var tNum = null;
    d.addEventListener('change', function (e) {
      var f = e.target.closest('[data-pb-filter-form]');
      if (f && e.target.type === 'checkbox') { load(formURL(f), true, false); return; }
      if (e.target.matches('[data-pb-sort]')) { var ff = d.querySelector('[data-pb-filter-form]'); if (ff) load(formURL(ff), true, false); }
    });
    d.addEventListener('input', function (e) {
      var f = e.target.closest('[data-pb-filter-form]'); if (!f || e.target.type !== 'number') return;
      clearTimeout(tNum); tNum = setTimeout(function () { load(formURL(f), true, false); }, 600);
    });
    d.addEventListener('submit', function (e) { var f = e.target.closest('[data-pb-filter-form]'); if (f) { e.preventDefault(); load(formURL(f), true, false); } });
    d.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pb-collection] .pb-active a, [data-pb-collection] [data-pb-pag] a, [data-pb-collection] .pb-gamechips a');
      if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); load(a.href, true, !!a.closest('[data-pb-pag]')); return; }
      var dt = e.target.closest('[data-pb-desc-toggle]'); if (dt) { var wr = dt.parentElement, dd = wr.querySelector('.pb-coll__desc'), op = !wr.classList.contains('is-open'); if (!dd) { wr.classList.toggle('is-open', op); return; } /* animer fra tekstens præcise højde (ikke fra loftet på 60em) — ellers står den stille, før den lukker */ dd.style.transition = 'none'; dd.style.maxHeight = dd.getBoundingClientRect().height + 'px'; void dd.offsetHeight; dd.style.transition = ''; if (op) { wr.classList.add('is-open'); dd.style.maxHeight = dd.scrollHeight + 'px'; dd.addEventListener('transitionend', function te() { dd.removeEventListener('transitionend', te); if (wr.classList.contains('is-open')) dd.style.maxHeight = 'none'; }); } else { wr.classList.remove('is-open'); dd.style.maxHeight = ''; } return; }
      var fg = e.target.closest('[data-pb-fg]'); if (fg) { var g = fg.parentElement, op = !g.classList.contains('is-open'); g.classList.toggle('is-open', op); fg.setAttribute('aria-expanded', op ? 'true' : 'false'); return; }
      if (e.target.closest('[data-pb-filters-open]')) { var fl = d.querySelector('#pb-filters'); if (fl) { fl.classList.add('is-open'); PB.lock(true); } return; }
      if (e.target.closest('[data-pb-filters-close]')) { var fc = d.querySelector('#pb-filters'); if (fc) { fc.classList.remove('is-open'); PB.lock(false); } }
    });
    /* forudindlæs det filter/den side musen hviler på */
    var hov = null;
    d.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var lab = e.target.closest('[data-pb-filter-form] label'), a = e.target.closest('[data-pb-collection] [data-pb-pag] a, [data-pb-collection] .pb-active a, [data-pb-collection] .pb-gamechips a');
      clearTimeout(hov);
      hov = setTimeout(function () {
        if (lab) { var inp = lab.querySelector('input[type=checkbox]'); if (inp && !inp.disabled) PB.get(sectionURL(formURL(inp.form, inp)), { ttl: TTL }).catch(function () {}); }
        if (a) PB.get(sectionURL(a.href), { ttl: TTL }).catch(function () {});
      }, 90);
    });
    window.addEventListener('popstate', function () { load(location.href, false, false); });
    prefetchNext();
  });
})();
